import React from 'react';
// import { useStoreState } from 'easy-peasy';
import qs from 'querystringify';

import Layout from '../../../components/global/Layout';
import Details from './Details';

import Header from './Header';
import { Loading, Pagination } from '../../../components/elements';
import { useCmsData } from './helpers';
import Search from './Search';

const LISTSIZE = 50;

const PageActions = ({ location, history }) => {
  const routeState = qs.parse(location.search);
  const { name, status, page } = routeState;

  let nameFilter = null;

  if (name) {
    nameFilter = name;
  }

  let statusFilter = 'ACTIVE';

  if (status) {
    statusFilter = status;
  }

  const currentPage = parseInt(page, 10) - 1 >= 0 ? parseInt(page, 10) - 1 : 0;

  const {
    loading,
    pageCount,
    totalElements,
    cmsData: pageActions,
    refetch,
  } = useCmsData({
    pageActionId: '',
    name: nameFilter,
    status: statusFilter,
    from: currentPage * LISTSIZE,
    size: LISTSIZE,
    sort: 'UPDATED_DESC',
  });

  const [selectedPageAction, setSelectedPageAction] = React.useState(null);
  const [isActiveModal, setIsActiveModal] = React.useState(false);

  const activeModalProp = {
    selectedPageAction,
    setSelectedPageAction,
    isActiveModal,
    setIsActiveModal,
  };

  return (
    <Layout>
      <Header
        setSelectedPageAction={setSelectedPageAction}
        setIsActiveModal={setIsActiveModal}
      />
      <Search name={nameFilter} status={statusFilter} routeState={routeState} />
      {loading && <Loading />}

      {!loading && pageActions && pageActions?.length !== 0 && (
        <div>
          {totalElements > 0 && (
            <Pagination
              pageFrom={currentPage * LISTSIZE}
              pageCount={pageCount}
              listSize={LISTSIZE}
              totalElements={totalElements}
              currentPage={currentPage}
              handlePageClick={value => {
                history.push(
                  `/cms-page-actions${qs.stringify(
                    {
                      ...routeState,
                      page: value.selected + 1,
                    },
                    true,
                  )}`,
                );
              }}
            />
          )}
          <Details
            pageActions={pageActions}
            activeModalProp={activeModalProp}
            refetch={refetch}
          />
        </div>
      )}
    </Layout>
  );
};

export default PageActions;
